import { render, staticRenderFns } from "./Header3.vue?vue&type=template&id=4ca30df6&scoped=true&"
import script from "./Header3.vue?vue&type=script&lang=js&"
export * from "./Header3.vue?vue&type=script&lang=js&"
import style0 from "./Header3.vue?vue&type=style&index=0&id=4ca30df6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca30df6",
  null
  
)

export default component.exports